module.exports = __webpack_public_path__ + "static/media/king-on-africa.3cca9d1b.jpg";